import { WORK_STATUS } from '../../constants'

/**
 * Tính tiến độ hoàn thành (0-100) của một công việc
 * @param {Object} item Công việc cần tính
 * @returns {number} 0-100
 */
export const calcWorkProgress = (item) => {
  if (!item) return 0
  
  const subwork = item.subwork || []
  
  // Nếu có công việc con, tính theo tỷ lệ hoàn thành
  if (subwork.length > 0) {
    const doneCount = subwork.filter(s => s.status === WORK_STATUS.COMPLETE).length
    return Math.round((doneCount / subwork.length) * 100)
  }
  
  // Nếu là công việc cha không có con, hoặc là công việc con (dựa theo trạng thái)
  return item.status === WORK_STATUS.COMPLETE ? 100 : 0
}
